import exifr from "exifr";
import { api } from "@/lib/api";
import { colonyApi } from "@/lib/colonyApi";

const stillOf = (value) => {
  if (typeof value !== "string" || !value.startsWith("live-photo:")) return value || "";
  try { return JSON.parse(value.slice("live-photo:".length)).image || ""; } catch { return ""; }
};
const isColony = (client) => client === colonyApi || (!client && window.location.pathname.startsWith("/colon"));
const base = (client) => (isColony(client) ? "/colony/photo-times" : "/photo-times");

// The moment the camera took the photo (EXIF), else the file's own time.
export async function readTakenAt(file) {
  try {
    const tags = await exifr.parse(file, ["DateTimeOriginal", "CreateDate"]);
    const when = tags?.DateTimeOriginal || tags?.CreateDate;
    if (when instanceof Date && !Number.isNaN(when.getTime())) return when.toISOString();
  } catch { /* no EXIF */ }
  return file?.lastModified ? new Date(Math.min(file.lastModified, Date.now())).toISOString() : null;
}

export async function hashPhoto(value) {
  const still = stillOf(value);
  if (!still || !window.crypto?.subtle) return "";
  const digest = await window.crypto.subtle.digest("SHA-256", new TextEncoder().encode(still));
  return Array.from(new Uint8Array(digest)).map((b) => b.toString(16).padStart(2, "0")).join("");
}

// Remembers when each new photo was snapped so viewers can show it later.
export async function registerPhotoTimes(pairs, client) {
  try {
    const items = (await Promise.all(pairs.map(async ([file, value]) => ({ hash: await hashPhoto(value), taken_at: await readTakenAt(file) }))))
      .filter((it) => it.hash && it.taken_at);
    if (items.length) await (isColony(client) ? colonyApi : api).post(base(client), { items });
  } catch { /* best effort */ }
}

const known = new Map();
export async function lookupPhotoTime(value) {
  const hash = await hashPhoto(value);
  if (!hash) return null;
  if (known.has(hash)) return known.get(hash);
  try {
    const client = isColony() ? colonyApi : api;
    const { data } = await client.get(base(), { params: { h: hash } });
    const when = data?.times?.[hash] || null;
    if (when) known.set(hash, when);
    return when;
  } catch { return null; }
}
